"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function IconField(props) {
  var field = props.field,
    form = props.form,
    disabled = props.disabled;
  var current = field === null || field === void 0 ? void 0 : field.value;
  function renderField() {
    if (disabled) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-secondary",
        disabled: true,
        type: "button"
      }, "Select Image");
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, current && (current === null || current === void 0 ? void 0 : current.thumbnailSmall) && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].iconPreview,
      style: {
        backgroundImage: "url(".concat(current.thumbnailSmall, ")")
      }
    }), /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
      trigger: /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-secondary",
        type: "button"
      }, current ? 'Change Image' : 'Select Image'),
      value: current,
      onChange: function onChange(val) {
        form.setFieldValue(field.name, val);
        form.setFieldTouched(field.name);
      }
    }), current && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Remove Icon"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-danger ' + _style["default"].deleteButton,
      type: "button",
      onClick: function onClick() {
        // Must explicitly be undefined or ImagePicker will throw error
        form.setFieldValue(field.name, undefined);
        form.setFieldTouched(field.name);
      }
    }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null))));
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].iconField
  }, renderField()));
}
var _default = exports["default"] = IconField;